module.exports = __webpack_public_path__ + "img/Proofsheet - Gray - Selected.b9e3d0fa.png";